module.exports = __webpack_public_path__ + "media/fonts/fa-solid-900-cd7df21ebb1a5f7e146ffd5165bffb05.svg";